// Daten für Northlight Visuals – Premium Visual Production

export const companyInfo = {
  name: "Northlight Visuals",
  tagline: "Premium Visual Production",
  description: "Northlight Visuals produziert realistische Fashion- und Produktvisuals für Brands, die schneller, flexibler und effizienter arbeiten wollen – mit professioneller Nachbearbeitung und markengerechter Umsetzung.",
  email: "marouan@northlight-visuals.com",
  phone: "+49 151 55642989",
};

export const heroData = {
  headline: "High-End-Shooting-Qualität\nohne High-End-Shooting-Aufwand",
  subheadline: "Wir produzieren hochauflösende, kommerziell nutzbare Fashion-, Produkt- und Kampagnenvisuals in höchster Qualität – effizient umgesetzt auf Basis digitaler Produktion, professionell nachbearbeitet und für den direkten kommerziellen Einsatz in Shop, Ads, Social und Kampagnen ausgelegt.",
  badge: "Für echten Commercial Use",
  ctaPrimary: "Testprojekt anfragen",
  ctaSecondary: "Portfolio ansehen",
};

export const valueProps = [
  {
    id: 1,
    title: "Für echte Commercial Use Cases",
    description: "Geeignet für Shop, Ads, Social, Kampagnen und Produktlaunches – in höchster Qualität und so ausgearbeitet, dass die Visuals professionell eingesetzt werden können.",
    icon: "Target",
  },
  {
    id: 2,
    title: "Kein klassischer Produktionsaufwand",
    description: "Keine Modelbuchung, keine Location-Miete, keine Reiseplanung, keine klassische Shooting-Logistik.",
    icon: "Layers",
  },
  {
    id: 3,
    title: "Schnellere Umsetzung",
    description: "Erste finale Visuals in wenigen Tagen statt langer Produktionszyklen.",
    icon: "Zap",
  },
  {
    id: 4,
    title: "High-End Nachbearbeitung",
    description: "Jedes Visual wird professionell ausgearbeitet, damit es hochwertig, detailreich und nicht generisch oder künstlich wirkt.",
    icon: "Aperture",
  },
];

export const services = [
  {
    id: 1,
    title: "Creative Konzeption",
    description: "Wir entwickeln Bildideen, Stilrichtungen und Setups, die zur Positionierung deiner Brand und zum jeweiligen Einsatzbereich passen.",
    icon: "Lightbulb",
  },
  {
    id: 2,
    title: "Digitale Bildproduktion",
    description: "Wir produzieren realistische Produkt-, Model- und Kampagnenvisuals ohne die operative Komplexität klassischer Shootings.",
    icon: "Camera",
  },
  {
    id: 3,
    title: "High-End Retouching",
    description: "Jedes Visual wird professionell nachbearbeitet, damit Stoffe, Prints, Logos, Farben und Details hochwertig und markengerecht wirken.",
    icon: "Wand2",
  },
  {
    id: 4,
    title: "Marken- & Detailtreue",
    description: "Unser Fokus liegt auf einer sauberen visuellen Umsetzung, die Produkte, Branding und Designdetails überzeugend transportiert.",
    icon: "Shield",
  },
];

export const workflowSteps = [
  {
    id: 1,
    step: "01",
    title: "Produktbasis bereitstellen",
    description: "Entweder sendest du uns hochwertige, detaillierte Produktbilder – oder du schickst uns deine Produkte direkt zu.",
  },
  {
    id: 2,
    step: "02",
    title: "Studioaufnahme & digitale Produktion",
    description: "Falls nötig, fotografieren wir die Produkte im Studio als saubere Basis für die weitere visuelle Ausarbeitung und Produktion.",
  },
  {
    id: 3,
    step: "03",
    title: "Ausarbeitung & Rücksendung",
    description: "Wir erstellen die finalen Visuals, arbeiten sie professionell aus und senden dir zugeschickte Ware nach Abschluss selbstverständlich zurück.",
  },
];

export const stats = [
  {
    value: "Bis zu 70%",
    label: "weniger Produktionsaufwand",
    sublabel: "im Vergleich zu klassischen Shootings mit Model, Location und Crew",
  },
  {
    value: "Wenige Tage",
    label: "statt wochenlanger Zyklen",
    sublabel: "schnelle Umsetzung statt langer Abstimmung und Produktionsplanung",
  },
  {
    value: "High-End",
    label: "ausgearbeitete Visuals",
    sublabel: "in markengerechter Qualität für professionelle Einsatzzwecke",
  },
];

export const portfolioImages = [
  {
    id: 1,
    src: "/portfolio-rhode.jpg",
    alt: "Rhode – Social / UGC",
    category: "Social / UGC",
  },
  {
    id: 2,
    src: "/portfolio-byredo.jpg",
    alt: "Byredo – E-Commerce Visual",
    category: "E-Commerce",
  },
  {
    id: 3,
    src: "/portfolio-sl-palermo.jpg",
    alt: "Saint Laurent Palermo – Campaign",
    category: "Campaign",
  },
  {
    id: 4,
    src: "/portfolio-phonebooth.jpg",
    alt: "Phone Booth – Editorial",
    category: "Editorial",
  },
  {
    id: 5,
    src: "/portfolio-lv-bag.jpg",
    alt: "LV Keepall – Product",
    category: "Product",
  },
  {
    id: 6,
    src: "/portfolio-jilsander.jpg",
    alt: "Jil Sander – Product",
    category: "Product",
  },
  {
    id: 7,
    src: "/portfolio-angel-flowers.jpg",
    alt: "SL Angel – Campaign",
    category: "Campaign",
  },
  {
    id: 8,
    src: "/portfolio-arena.jpg",
    alt: "Stadium Editorial – On-Model",
    category: "Editorial",
  },
  {
    id: 9,
    src: "/portfolio-gloves.jpg",
    alt: "Miu Miu Gloves – Product Visual",
    category: "Product",
    wide: true,
  },
  {
    id: 10,
    src: "/portfolio-northlight-cam.jpg",
    alt: "Northlight – Campaign",
    category: "Campaign",
  },
  {
    id: 11,
    src: "/portfolio-leo-shirt.jpg",
    alt: "Saint Laurent Leo – On-Model",
    category: "On-Model",
  },
  {
    id: 12,
    src: "/portfolio-jacket.jpg",
    alt: "On-Model – Jacket Lookbook",
    category: "On-Model",
    wide: true,
  },
  {
    id: 13,
    src: "/portfolio-pink-cadillac.jpg",
    alt: "Pink Cadillac – Editorial",
    category: "Editorial",
  },
  {
    id: 14,
    src: "/portfolio-glass-door.jpg",
    alt: "Glass Door – Editorial",
    category: "Editorial",
  },
  {
    id: 15,
    src: "/portfolio-red-suits.jpg",
    alt: "Red & Pink Suits – Campaign",
    category: "Campaign",
  },
  {
    id: 16,
    src: "/portfolio-reifen.jpg",
    alt: "Tyre Editorial – On-Model",
    category: "Editorial",
  },
  {
    id: 17,
    src: "/portfolio-bag.jpg",
    alt: "Luxury Bag – Product Visual",
    category: "Product",
    wide: true,
  },
  {
    id: 18,
    src: "/portfolio-aesop.jpg",
    alt: "Aesop – Campaign Visual",
    category: "Campaign",
  },
  {
    id: 19,
    src: "/portfolio-lipstick.jpg",
    alt: "NARS Lipstick – Product",
    category: "Product",
  },
  {
    id: 20,
    src: "/portfolio-angel-campaign.jpg",
    alt: "Angel Campaign – Social / UGC",
    category: "Social / UGC",
    wide: true,
  },
  {
    id: 21,
    src: "/portfolio-porsche.jpg",
    alt: "Forest Porsche – Campaign",
    category: "Campaign",
  },
  {
    id: 22,
    src: "/portfolio-tennis.jpg",
    alt: "Tennis Court – Social / UGC",
    category: "Social / UGC",
  },
  {
    id: 23,
    src: "/portfolio-purple-legs.jpg",
    alt: "Purple Tights – E-Commerce",
    category: "E-Commerce",
    wide: true,
  },
  {
    id: 24,
    src: "/portfolio-gucci-shoe.jpg",
    alt: "Gucci Shoe – Product",
    category: "Product",
  },
  {
    id: 25,
    src: "/portfolio-leo-boots.jpg",
    alt: "Leopard Boots – On-Model",
    category: "On-Model",
  },
  {
    id: 26,
    src: "/portfolio-runway.jpg",
    alt: "Runway – On-Model",
    category: "On-Model",
  },
  {
    id: 27,
    src: "/portfolio-miu-ugc.jpg",
    alt: "Miu Miu Gloves – Social / UGC",
    category: "Social / UGC",
  },
  {
    id: 28,
    src: "/portfolio-silver-jacket.jpg",
    alt: "Silver Leather Jacket – Campaign",
    category: "Campaign",
    wide: true,
  },
];

export const pricingPackages = [
  {
    id: 1,
    name: "Testprojekt",
    subtitle: "Für Brands, die unseren Workflow mit ersten Visuals testen möchten",
    features: [
      "1 klar definierte Stilrichtung",
      "1–3 finale Visuals",
      "Professionelle Nachbearbeitung",
      "Ideal als Proof of Concept",
      "Schnelle Erstumsetzung",
    ],
    cta: "Testprojekt anfragen",
    color: "mid-purple",
    highlighted: false,
  },
  {
    id: 2,
    name: "Campaign Production",
    subtitle: "Für Brands mit regelmäßigem Bedarf an Kampagnen-, Shop- oder Ad-Visuals",
    features: [
      "Mehrere Visuals und Produktvarianten",
      "Flexible Stilrichtungen je nach Use Case",
      "High-End Retouching inklusive",
      "Geeignet für Shop, Social, Ads und Launches",
      "Individuelle Projektplanung",
    ],
    cta: "Projekt anfragen",
    color: "light-pink",
    highlighted: true,
  },
  {
    id: 3,
    name: "Creative Partner",
    subtitle: "Für Marken mit laufendem Content-Bedarf und Wunsch nach langfristiger Zusammenarbeit",
    features: [
      "Fortlaufende Visual Production",
      "Priorisierte Bearbeitung",
      "Feste Abstimmung und Ansprechpartner",
      "Planbare Umsetzung über längere Zeiträume",
      "Auf Wunsch diskrete Zusammenarbeit",
    ],
    cta: "Partnerschaft anfragen",
    color: "mid-blue",
    highlighted: false,
  },
];

export const targetAudience = [
  {
    id: 1,
    title: "Fashion- und Accessoire-Brands",
    description: "mit regelmäßigem Bedarf an Kampagnen-, Shop- und Social-Visuals",
  },
  {
    id: 2,
    title: "E-Commerce-Unternehmen",
    description: "für Produktbilder, Lookbooks und Ad Creatives in professioneller Qualität",
  },
  {
    id: 3,
    title: "Marken für Taschen, Schuhe, Schmuck & Lederwaren",
    description: "die hochwertige Produktvisuals ohne klassischen Shooting-Aufwand benötigen",
  },
  {
    id: 4,
    title: "Teams mit Anspruch an Qualität und Diskretion",
    description: "die schneller produzieren möchten, ohne Kompromisse bei Markenwirkung einzugehen",
  },
];

export const availableTimeSlots = [
  "11:00",
  "12:00",
  "13:00",
  "14:00",
  "15:00",
  "16:00",
  "17:00",
  "18:00",
];
